import { useMemo } from "react";

import type { ColumnType } from "@similarweb/pro-logic-components";
import { ChangeCell } from "@similarweb/pro-logic-components";

import { useTranslation } from "pro-features/components/WithTranslation";

export interface IRankChangeData {
    popRankChange?: number | null;
    yoyRankChange?: number | null;
}

export const useRankChangeColumnConfig = () => {
    const translate = useTranslation();
    const sharedConfig = useMemo(
        () => ({
            title: translate("bt.report.channels.share-of-channel-traffic-competitors-table.rank-change"),
            width: 100,
            minWidth: 100,
            align: "right" as const,
            render: (value?: number | null) => (
                <ChangeCell
                    value={value ?? undefined}
                    noChangeSign="0"
                />
            ),
        }),
        [translate],
    );

    return useMemo(
        () =>
            [
                {
                    ...sharedConfig,
                    dataIndex: "popRankChange",
                },
                {
                    ...sharedConfig,
                    dataIndex: "yoyRankChange",
                },
            ] satisfies ColumnType<IRankChangeData>[],
        [sharedConfig],
    );
};
